import PropTypes from "prop-types";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper } from "swiper/react";

import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";

import { GrNext } from "components/atoms/Icon/gr/GrNext";
import { GrPrevious } from "components/atoms/Icon/gr/GrPrevious";
import Title from "components/atoms/Title";

import styles from "./Index.module.scss";

const swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  pagination: {
    el: ".bbc-slide-pagination",
    clickable: true,
    bulletClass: "bbc-pagination-bullet",
  },
  navigation: {
    nextEl: ".bbc-button-next",
    prevEl: ".bbc-button-prev",
  },
  slidesPerView: 3,
  spaceBetween: 30,
  // Responsive breakpoints
  breakpoints: {
    1280: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30,
      slidesPerGroup: 2,
    },

    768: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1,
      navigation: true,
    },
  },
};
/** ========== */
const PostSlider = ({
  thetitle,
  navResponsiveClass,
  paginationResponsiveClass,
  children,
  description,
  ...props
}) => {
  return (
    <div className={"relative"}>
      {thetitle && (
        <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
          {thetitle}
        </Title>
      )}
      {description && (
        <p className="mb-6 text-center lg:mb-10">{description}</p>
      )}
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        className={" !p-4"}
        {...swiper}
        {...props}
      >
        {children}
        <div
          className={`bbc-slide-pagination relative  block pt-6 text-center ${
            props.showPaginationClass || " lg:invisible"
          } ${paginationResponsiveClass}`}
        ></div>
      </Swiper>

      <div
        className={`absolute top-1/2 left-1/2 hidden w-full -translate-x-1/2 -translate-y-1/2 lg:flex ${navResponsiveClass}`}
      >
        <div className={`bbc-button-prev ${styles.btn}  ${styles.btnPrev} `}>
          <GrPrevious size={18} className="text-red-400" />
        </div>
        <div className={`bbc-button-next ${styles.btn}  ${styles.btnNext} `}>
          <GrNext size={18} className="text-red-400" />
        </div>
      </div>
    </div>
  );
};

export default PostSlider;

PostSlider.propTypes = {
  thetitle: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.any,
};

PostSlider.defaultProps = {
  thetitle: null,
};

/** ========== */
